import React, { useState, useRef } from 'react';
import { Input } from 'reactstrap';
import MentionAutocomplete from './components/MentionAutocomplete';
import { MentionsInput, Mention } from 'react-mentions';
import { CREATE_CONVERSATION_NOTE } from '../Mutations';
import { useMutation, useQuery } from '@apollo/client';
import { RepsQuery } from '../../Functions/querys';
import searchRepsWithClient from '../../Functions/searchRepsWithClient';
import RepMentionsInput from '../../Functions/RepMentionsInput';

export default function ConversationNoteComposer({ conversationId }) {
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [cursorPosition, setCursorPosition] = useState(0);
    const [showMentionAutocomplete, setShowMentionAutocomplete] = useState(false);
    const [createConversationNoteMutation] = useMutation(CREATE_CONVERSATION_NOTE);
    const inputRef = useRef(null);
    
    const handleSubmit = async (e) => {
        if (message.trim() === "" || loading) {
            return;
        }
        e.preventDefault();
        // Clear previous error
        setError("");
        setLoading(true);
        try {
            const { data } = await createConversationNoteMutation({
                variables: {
                    conversationId,
                    note: message,
                },
            });
            setLoading(false);
            if (data.messagingCreateConversationNote.ok) {
                setMessage("");
            } else {
                setError(data.messagingCreateConversationNote.errors.join(", "));
            }
        } catch (err) {
            setError("An unexpected error occurred.");
            setLoading(false);
        }
    };

    const handleTextareaChange = (e) => {
        // e.preventDefault();
        const newValue = e.target.value;
        const newCursorPos = e.target.selectionStart;
        setMessage(newValue);
        setCursorPosition(newCursorPos);
        
        // Check for @ mention
        const textBeforeCursor = newValue.substring(0, newCursorPos);
        const lastAtIndex = textBeforeCursor.lastIndexOf('@');
        if (lastAtIndex !== -1) {
            const charBefore = lastAtIndex > 0 ? textBeforeCursor[lastAtIndex - 1] : ' ';
            if (/\s/.test(charBefore) || lastAtIndex === 0) {
                const query = textBeforeCursor.substring(lastAtIndex + 1);
                if (!/\s/.test(query)) {
                    setShowMentionAutocomplete(true);
                    return;
                }
            }
        }
        setShowMentionAutocomplete(false);
    };

    const handleKeyDown = (e) => {
        // Enter to send (unless Shift is held)
        if (showMentionAutocomplete) {
            return;
        }
        // Escape to close modals/autocompletes
        if (e.key === 'Escape') {
            setShowMentionAutocomplete(false);
        }
        
        // Submit on Enter
        if (e.keyCode === 13 && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };


    return (
        <div>
            {error && <div className="alert alert-danger mt-2">{error}</div>}
        
            <div className="ConversationNoteComposer">
                {/* <Input
                    type="input"
                    innerRef={inputRef}
                    disabled={loading}
                    className="input-form"
                    placeholder="Leave an internal comment..."
                    value={message}
                    onChange={(e) => handleTextareaChange(e)}
                    onKeyDown={(e) => handleKeyDown(e)}
                    row={1}
                /> */}
                {/* {showMentionAutocomplete && (
                    <MentionAutocomplete
                        textareaRef={inputRef}
                        message={message}
                        setMessage={setMessage}
                        cursorPosition={cursorPosition}
                        onClose={() => setShowMentionAutocomplete(false)}
                    />
                )} */}
                {/* <MentionsInput placeholder="Write an update and mention someone with @" value={message} onChange={(e) => setMessage(e.target.value)} className="text-area">
                    <Mention
                        trigger="@"
                        data={(search, callBack) => searchRepsWithClient(props.apolloClient, search, callBack, { boardId })}
                        data={(search, callBack) => searchRepsWithClient(props.apolloClient, search)}
                        className="mention"
                        displayTransform={(id, display) => `@${display}`}
                        appendSpaceOnAdd={true}
                        renderSuggestion={(suggestion, search, highlightedDisplay) => renderMentionSuggestion(suggestion, highlightedDisplay)}
                    />
                </MentionsInput> */}
                <RepMentionsInput
                    value={message}
                    className="input-form"
                    mentionStyle={{ bottom:0 }}
                    onChange={(e) => setMessage(e.target.value)}
                    // renderMentionSuggestion={renderMentionSuggestion}
                    />
                <div className="note-actions">
                    <span className={`note-actions-submit ${message.trim() === "" || loading ? "disabled" : ""}`} onClick={(e) => handleSubmit(e)}><i className="fa fa-comment" aria-hidden="true"></i></span>
                </div>
            </div>
        </div>
    );
}

